// extracted by mini-css-extract-plugin
module.exports = {"inline_loader":"InlinePageLoader_inline_loader__835tv","container":"InlinePageLoader_container__XDHUR"};